import React from 'react';
import { Field, getFormValues, isValid, reduxForm } from 'redux-form';
import SettingField from 'components/Fields/ReduxForm/SettingField/SettingField';
import { connect } from 'react-redux';
import { onClickAssignOutletButton } from 'actions/businessLibrary/promo/promo';
import styles from './PromoTypeAndName.css';
import AssignPromoToOutletModal from './AssignPromoToOutletModal';

const validate = values => {
  const errors = {};
  if (!values.promoName || values.promoName.trim() === '') {
    errors.promoName = 'This field is required';
  } else if (values.promoName.length > 25) {
    errors.promoName = 'The maximum character of promo name is 25';
  }
  if (!values.promoType) {
    errors.promoType = 'This field is required';
  }
  return errors;
};

const radioField = field => {
  const {
    type,
    typeProps: { description, name },
    logo,
  } = field;
  return (
    <label
      className={
        name === 'Buy X Get Y' ? styles.label : styles['label-disabled']
      }
    >
      <input {...field.input} type={type} disabled={name !== 'Buy X Get Y'} />
      <div className={styles['media-wrapper']}>
        <div className="media">
          <div className="media-left">
            <img src={logo} />
          </div>
          <div className="media-body">
            <p className={styles.name}>
              {name} {name !== 'Buy X Get Y' ? '(Coming Soon)' : ''}
            </p>
            <p className={styles.description}>{description}</p>
          </div>
        </div>
      </div>
    </label>
  );
};

class PromoTypeAndName extends React.Component {
  render() {
    const {
      handleSubmit,
      promoTypeForm,
      promoTypes,
      isValidForm,
      isSubmittingForm,
      detailPromo,
      selectedOutlets,
    } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <label className={styles['label-type']}>
          {!detailPromo
            ? 'Choose the promo type you want to create'
            : 'The promo type you have created'}
        </label>
        {detailPromo &&
          promoTypes.map((promo, idx) => {
            const promoLogo = promo.name.toLowerCase().replace(/ /g, '-');
            if (promo.id === detailPromo.promo_type_id) {
              return (
                <div key={promo.id}>
                  <Field
                    name="promoType"
                    component={radioField}
                    type="radio"
                    value={promo.name}
                    typeProps={promo}
                    currentValue={promoTypeForm}
                    logo={
                      idx < 3
                        ? require(`assets/images/ic-${promoLogo}.png`)
                        : 'http://via.placeholder.com/42x42'
                    }
                  />
                </div>
              );
            }
          })}
        {!detailPromo &&
          promoTypes.map((promo, idx) => {
            const promoLogo = promo.name.toLowerCase().replace(/ /g, '-');
            return (
              <div key={promo.id}>
                <Field
                  name="promoType"
                  component={radioField}
                  type="radio"
                  value={promo.name}
                  typeProps={promo}
                  currentValue={promoTypeForm}
                  logo={
                    idx < 3
                      ? require(`assets/images/ic-${promoLogo}.png`)
                      : 'http://via.placeholder.com/42x42'
                  }
                />
              </div>
            );
          })}
        <div className={styles['set-menu']} />
        <label className={styles['label-name']}>Input your promo name</label>
        <Field
          component={SettingField}
          name="promoName"
          type="text"
          className="form-control"
          placeholder="e.g. Buy 1 Get 1 Free"
        />
        <label className={styles['label-assign-outlet']}>
          Where do you want to implement this promo?
        </label>
        <p className={styles['sub-label-assign-outlet']}>ASSIGNED OUTLETS</p>
        <ul>
          {selectedOutlets.length > 0 &&
            selectedOutlets.map(outlet => {
              return (
                outlet && outlet.checked && <p key={outlet.id}>{outlet.name}</p>
              );
            })}
        </ul>
        <button
          type="button"
          className={`btn btn-primary ${styles['btn-assign-outlet']}`}
          onClick={this._clickAssignOutlet}
        >
          Assign Outlet
        </button>

        <button
          type="submit"
          className={`btn btn-default ${styles['btn-next']}`}
          disabled={
            !isValidForm ||
            !this._shouldEnableNext(selectedOutlets) ||
            isSubmittingForm
          }
        >
          {isSubmittingForm && (
            <i
              className="fa fa-spinner fa-pulse fa-3x fa-fw"
              style={{ fontSize: 'medium' }}
            />
          )}{' '}
          Next
        </button>
        <AssignPromoToOutletModal />
      </form>
    );
  }

  _clickAssignOutlet = () => {
    const { selectedOutlets, assignOutletForm } = this.props;
    this.props.dispatch(
      onClickAssignOutletButton(
        selectedOutlets,
        assignOutletForm.selectedOutlets
      )
    );
  };

  _shouldEnableNext = selectedOutlets => {
    let idx = 0;
    let anySelected = false;
    while (idx < selectedOutlets.length) {
      if (selectedOutlets[idx].checked) {
        anySelected = true;
        break;
      }
      idx++;
    }
    return anySelected;
  };
}

const mapForm = {
  form: 'promoTypeAndName',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

function mapStateToProps(state) {
  const {
    promoTypes,
    selectedOutlets,
    isSubmittingForm,
    detailPromo,
  } = state.businessLibrary.promo;
  return {
    promoTypes,
    selectedOutlets,
    isSubmittingForm,
    promoTypeForm: getFormValues('promoTypeAndName')(state),
    isValidForm: isValid('promoTypeAndName')(state),
    assignOutletForm: getFormValues('promoAssignOutlet')(state),
    detailPromo,
  };
}

export default connect(mapStateToProps)(reduxForm(mapForm)(PromoTypeAndName));
